import { gql } from "@apollo/client";

export const SCRAPE = gql`
  mutation scrape($id: Int!) {
    scrape(id: $id) {
      id
      message
      isError
    }
  }
`;
